"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dropzone_1 = require("react-dropzone");
var Button_1 = __importDefault(require("../Button"));
var IllustratedMessage_1 = __importDefault(require("../IllustratedMessage"));
var theme_1 = __importDefault(require("../../theme"));
var styles_1 = require("./styles");
function FilePicker(_a) {
    var _b = _a.files, files = _b === void 0 ? [] : _b, setFiles = _a.setFiles, options = _a.options, onDropRejected = _a.onDropRejected, style = _a.style, messages = _a.messages, illustration = _a.illustration;
    var _c = (0, react_dropzone_1.useDropzone)(__assign(__assign({}, options), { onDrop: function (acceptedFiles) {
            setFiles(__spreadArray(__spreadArray([], files, true), acceptedFiles, true));
        }, onDropRejected: function (event) {
            onDropRejected && onDropRejected(event);
        } })), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps, isDragActive = _c.isDragActive;
    function handleRemoveFile(selectedFile) {
        setFiles(files.filter(function (file) {
            console.log({ file: file, selectedFile: selectedFile });
            return selectedFile.name !== file.name;
        }));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.MainContainer, { style: style },
            react_1.default.createElement("input", __assign({}, getInputProps())),
            react_1.default.createElement(styles_1.SelectContainer, __assign({}, getRootProps()),
                react_1.default.createElement(IllustratedMessage_1.default, { illustration: (illustration === null || illustration === void 0 ? void 0 : illustration.type) || "documents", illustrationConfigs: __assign({ height: "64px" }, illustration === null || illustration === void 0 ? void 0 : illustration.configs), body: isDragActive
                        ? (messages === null || messages === void 0 ? void 0 : messages.onDrag) || "Suelta aquí tus archivos..."
                        : (messages === null || messages === void 0 ? void 0 : messages.default) ||
                            "Arrastra tus archivos aquí, o haz click para seleccionar", bodyStyle: { marginTop: 16 } })),
            react_1.default.createElement(styles_1.FilesContainer, null, files.map(function (file, index) {
                return (react_1.default.createElement(styles_1.FileContainer, { key: index },
                    react_1.default.createElement(styles_1.Paragraph, null, file.name),
                    react_1.default.createElement(Button_1.default, { variant: "primary", format: "link", size: "small", onClick: function () {
                            handleRemoveFile(file);
                        } }, "Quitar")));
            }))),
        (messages === null || messages === void 0 ? void 0 : messages.error) && (react_1.default.createElement("p", { style: { color: theme_1.default.colorsPalette.red.default, marginLeft: 10 } }, messages === null || messages === void 0 ? void 0 : messages.error))));
}
exports.default = FilePicker;
//# sourceMappingURL=index.js.map